module.exports = __webpack_public_path__ + "static/media/back-arrow-header.499c8ad6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/suttonparkbus/back-arrow-header.svg
// module id = 303
// module chunks = 0